import { render } from "./DrawSignature.vue?vue&type=template&id=2f36d937"
import script from "./DrawSignature.vue?vue&type=script&lang=js"
export * from "./DrawSignature.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__